import type { Candidate } from '../repository'

import featureGridMeta from '@cogo/schema/blocks-v2/feature/feature-grid/block.cogo.json'
import featureGridUi from '@cogo/schema/blocks-v2/feature/feature-grid/ui.cogo.json'
import featureGridEvents from '@cogo/schema/blocks-v2/feature/feature-grid/events.cogo.json'
import featureGridFlow from '@cogo/schema/blocks-v2/feature/feature-grid/flow.cogo.json'
import featureGridVariables from '@cogo/schema/blocks-v2/feature/feature-grid/variables.cogo.json'
import featureGridDatasource from '@cogo/schema/blocks-v2/feature/feature-grid/datasource.cogo.json'
import { cloneBlockDef, appendRootClassName } from './util'

function buildFeatureGridVariant(variant: 'default' | 'twoColumn' | 'withIcons') {
  const base = cloneBlockDef({
    meta: featureGridMeta,
    ui: featureGridUi,
    events: featureGridEvents,
    flow: featureGridFlow,
    state: featureGridVariables,
    data: featureGridDatasource,
  })
  if (variant === 'twoColumn') appendRootClassName(base, 'grid-cols-2')
  if (variant === 'withIcons') appendRootClassName(base, 'gap-6 [&_.icon]:text-primary')
  return base
}

export const galleryCandidates: Candidate[] = [
  {
    id: 'gallery-a',
    exampleId: 'cexample:feature-grid-default',
    patternId: 'cpat:feature-grid',
    dsId: 'ds:shadcn',
    cogoJson: buildFeatureGridVariant('default'),
    narrativeHeadline: 'Feature grid · 3-column benefit showcase',
    dsCompatibility: 'exact',
    score: 90,
  },
  {
    id: 'gallery-b',
    exampleId: 'cexample:feature-grid-two-column',
    patternId: 'cpat:feature-grid',
    dsId: 'ds:shadcn',
    cogoJson: buildFeatureGridVariant('twoColumn'),
    narrativeHeadline: 'Two-column feature grid · wider content layout',
    dsCompatibility: 'exact',
    score: 82,
  },
  {
    id: 'gallery-c',
    exampleId: 'cexample:feature-grid-with-icons',
    patternId: 'cpat:feature-grid',
    dsId: 'ds:shadcn',
    cogoJson: buildFeatureGridVariant('withIcons'),
    narrativeHeadline: 'Icon-accented feature grid · visual hierarchy',
    dsCompatibility: 'exact',
    score: 87,
  },
]
